let expresionOnlyEmail = /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,3})$/;
let expresionNoSpaces = /^\s+$/;
let currErrosRegister = new Map();

const octoAsync = async function (
  currUrl,
  currMethod,
  currHeaders,
  currData = ''
) {
  let response
  if (currData !== '') {
    response = await fetch(`${currUrl}`, {
      method: currMethod,
      body: JSON.stringify(currData),
      headers: currHeaders,
    })
  } else {
    response = await fetch(`${currUrl}`, {
      method: currMethod,
      headers: currHeaders,
    })
  }
  const responseJSON = await response.json()
  return responseJSON
}

const withoutSpaces = function(currValue, currId, currName){
  if(currValue === 0 || currValue === undefined || currValue === "" || expresionNoSpaces.test(currValue) || currValue.length < 1){
    currErrosRegister.set(currId, `El campo ${currName} es requerido.`);
  }
}

const onlyEmail = function(currValue, currId, currName){
  if(currValue === 0 || currValue === undefined || currValue === "" || !expresionOnlyEmail.test(currValue)){
    currErrosRegister.set(currId, `El campo ${currName} es requerido.`);
  }
}

const onlyPhoneNumber = function(currValue, currId, currName){
  if(currValue === 0 || currValue === undefined || currValue === "" || expresionNoSpaces.test(currValue) || currValue.length != 10 || isNaN(currValue)){
    if(currName === "Celular"){
      currErrosRegister.set(currId, `El campo ${currName} es requerido y a 10 dígitos. (sin espacios y solo números)`);
    }else{
      currErrosRegister.set(currId, `El campo ${currName} es requerido y a 10 dígitos. (o déjalo en blanco y sigue con tu registro) `);
    }
  }
}

const verifyEmailShopify = async function (currEmail, thisElement) {
  let headers = {
  }
  let response = await octoAsync(`https://www.natshop.com/apps/natshopv2?action=validate_acount&email=${currEmail}`, `GET`, headers, ``);
  if(response.status === `failed` ){
    let template = `<div id="custom-register-errors">
        <span>❎</span>
        Esta dirección de correo electrónico (${currEmail}) ya está en uso. Por favor, pruebe con otra.
      </div>`;
    $(thisElement).before(template);
  }else{
    $(thisElement).parents(`#create_customer`).submit();
  }
}

const updatePhone = async function (currValue) {
  let headers = {
    'Content-type': 'application/json',
  }
  let response = await octoAsync(`https://natshop.octocode.xyz/api/v1/update_phone_number/${customerId}`, `POST`, headers, {phone: Number(currValue)});
  if(response.status === "success"){
    $(`.phone-change-notice`).remove();
    $(`.phone-popup`).removeClass(`active`);
  }else{
    $(`.formulario-phone .errors`).html(response.msg);
  }
}

const verifyProductStatus = async function (customerEmail, productId) {
  let headers = {
  }
  let response = await octoAsync(`https://www.natshop.com/apps/natshopv2?action=customer_has_sales&email=${customerEmail}&product_id=${productId}`, `GET`, headers, ``);
  if(response.status === `success` ){
    window.location.href = "/";
  }else{
    $("#product-component-1671466276136").addClass("active");
  }
}

const animateTopSection = function(thisElement){
  $('html, body').animate({
    scrollTop: $(thisElement).position().top
  }, 800);
}

const returWith0 = function(value){
  if(value.toString().length == 1){
    return `0${value}`;
  }else{
    return value;
  }
}

const returNegative0 = function(value){
  if(value < 0){
    return 0;
  }else{
    return value;
  }
}

const withoutTime = function(dateTime) {
  let date = new Date(dateTime)
  const [month, day, year] = [date.getMonth() + 1, date.getDate(), date.getFullYear()];
  return `${returWith0(day)}/${returWith0(month)}/${year}`
}

const returDateTypeBank = function(dateTime){
  let newDate = dateTime.split('/')
  let date = new Date(newDate[1]) 
  let month = ``
  switch (newDate[1]) {
    case '01':
      month = `Enero`
      break;
    case '02':
      month = `Febrero`
      break;
    case '03':
      month = `Marzo`
      break;
    case '04':
      month = `Abril`
      break;
    case '05':
      month = `Mayo`
      break;
    case '06':
      month = `Junio`
      break;
    case '07':
      month = `Julio`
      break;
    case '08':
      month = `Agosto`
      break;
    case '09':
      month = `Septiembre`
      break;
    case '10':
      month = `Octubre`
      break;
    case '11':
      month = `Noviembre`
      break;
    case '12':
      month = `Diciembre`
      break;
    default:
      month = `No es mes`
      console.log(`No es mes`);
  }
  return `Fecha de corte ${newDate[0]} de ${month}`
}

const cartWaitBtn = function(){
  $(`button.cart-recap__checkout`).prop("disabled",true);
  /*setTimeout(function(){
    $(`button.cart-recap__checkout`).prop("disabled",false);
  }, 3000);*/
}

const menuAccountStatus = function(element){
  if(element.parent().hasClass(`active`)){
    element.find(`span`).text(`Ver menú`);
  }else{
    element.find(`span`).text(`Cerrar menú`);
  }
  element.parent().toggleClass(`active`);
}

const menuSlider = function(){
  if($(`.natshop-section-cont__menu__2`).length > 0){
    $('.natshop-section-cont__menu__2 .owl-carousel').owlCarousel({
      loop: false,
      margin:0,
      nav:false,
      dots: false,
      stagePadding: 0,
      responsive:{
          300:{
              items:3
          },
          400:{
              items:3
          },
          500:{
              items:4
          },
          600:{
              items:5
          },
          700:{
              items:6
          },
          1000:{
              items:6
          }
      }
    }) 
  }
}

const calculateHeightCategoryImage = function(){
  let currWidthContainer = $(".section-categories-natshop__item__bg").width();
  $(".section-categories-natshop__item__img").width(currWidthContainer);
  $(".section-categories-natshop__item__img").height(currWidthContainer);
}

function checkInp()
{
  var x=document.forms["myForm"]["age"].value;
  if (isNaN(x)) 
  {
    alert("Must input numbers");
    return false;
  }
}

const updatePhothoChatWhatsapp = function(){
  $("#chat-widget-agent-list > .chat-list-cont:nth-child(1) .chat-user-avatar > img").attr("src", "https://cdn.shopify.com/s/files/1/0196/6302/8286/files/WhatsApp_Image_2023-01-11_at_12.06.08.jpg?v=1673461127");
  $("#chat-widget-agent-list > .chat-list-cont:nth-child(2) .chat-user-avatar > img").attr("src", "https://cdn.shopify.com/s/files/1/0196/6302/8286/files/WhatsApp_Image_2023-01-11_at_12.06.08.jpg?v=1673461127");
}

const calculateMarginBottomVideo = function(){
  let currHeightVideoDescription = $(".afiliate-custom-page__video__description").outerHeight();
  $(".afiliate-custom-page__video").css("margin-bottom", `${ currHeightVideoDescription + 20}px`);
}

const removeCookieGoToCheckout = function(){
  if(window.location.pathname != "/account/login" && window.location.pathname != "/pages/event-register-to-fb-pixel"){
    $.cookie("gocheckoutpage", 0, { path: '/' });
  }
}

$(function(){

  removeCookieGoToCheckout();
  if($("body.afiliate-distribuidor").length > 0 || $("body.afiliate-reclutador").length > 0){
    calculateMarginBottomVideo();
  }

  $(document).on("click", "#chwhatsapp-btn", function(){
    updatePhothoChatWhatsapp();
  });

  $(window).on("resize", function(){
    if($("body.afiliate-distribuidor").length > 0 || $("body.afiliate-reclutador").length > 0){
      calculateMarginBottomVideo();
    }
  });

  menuSlider();

  let addInput = '.product-form__quantity__new';
  let productSelectQuantity = '.product-form__quantity__hide';
  let currValueQuantity = 1;
  $(addInput).val(currValueQuantity);
  $('.quantity-selector__button__new.quantity-selector__button--plus').on('click', function(){
    if (currValueQuantity >= 10) {
      $(addInput).val(10);
      $(productSelectQuantity).val(currValueQuantity).trigger("change");
    } else {
      $(addInput).val(++currValueQuantity);
      $(productSelectQuantity).val(currValueQuantity).trigger("change");
    }
  })
  $('.quantity-selector__button__new.quantity-selector__button--minus').on('click', function(){
    if (currValueQuantity > 1) {
      $(addInput).val(--currValueQuantity);
      $(productSelectQuantity).val(currValueQuantity).trigger("change");
    } else {
      $(addInput).val(1);
      $(productSelectQuantity).val(1).trigger("change");
    }
  });
  $(document).on('blur', '.product-form__quantity__new', function () {
    let x = $(this).val();
    if(isNaN(x)){
      $(addInput).val(1).trigger("change");
      $(productSelectQuantity).val(1).trigger("change");
      currValueQuantity = 1;
    }else{
      if(x > 10){
        $(addInput).val(10).trigger("change");
        $(productSelectQuantity).val(10).trigger("change");
        currValueQuantity = 10;
      }else if(x < 1){
        $(addInput).val(1).trigger("change");
        $(productSelectQuantity).val(1).trigger("change");
        currValueQuantity = 1;
      }else{
        $(addInput).val(x).trigger("change");
        $(productSelectQuantity).val(x).trigger("change");
        currValueQuantity = x;
      }
    }
  });

  calculateHeightCategoryImage();

  $(window).on('resize', function () {
    calculateHeightCategoryImage();
  });

  // fancybox customisation
  $('[data-fancybox]').fancybox({
  	buttons: [
      "zoom",
      "slideShow",
      "fullScreen",
      "download",
      "thumbs",
      "close"
    ],
      protect: true,
      preventCaptionOverlap: true
  });
  
  if($(`body.template-cart`)){
    cartWaitBtn();
  }

  $(document).on("click", ".jdgm-rev-widg__summary", function(e){
    let body = $("html, body");
    body.stop().animate({scrollTop:$("#product-reviews").offset().top}, 500, 'swing', function() {
    });
  });
  
  
   $(document).on("click", "#octo-btn-register-submit", function(e){
  
    e.preventDefault();
    
    let currentElement = this;
    
    currErrosRegister.clear()
    
    $(`#custom-register-errors`).remove();
                                                                   
    let firstName = $(`#create_customer.acc [data-id="first_name"]`).val();
    let lastName = $(`#create_customer.acc  [data-id="last_name"]`).val();
    let phone = $(`#create_customer.acc  [data-id="phone"]`).val();
    let email = $(`#create_customer.acc  [data-id="email"]`).val();
    let password = $(`#create_customer.acc  [data-id="password"]`).val();
    let phoneReferal = $(`#create_customer.acc  [data-id="phone-referal"]`).val();
    withoutSpaces(firstName, `first_name`, `Nombre`);
    withoutSpaces(lastName, `last_name`, `Apellidos`);
    //withoutSpaces(phone, `phone`, `Celular`);
    onlyPhoneNumber(phone, `phone`, `Celular`);
    onlyEmail(email,`email`, `Email`);
    withoutSpaces(password, `password`, `Contraseña`);
    if(phoneReferal){
      onlyPhoneNumber(phoneReferal, `phone-referal`, `Celular de quien te Invitó`);
    }
    if(currErrosRegister.size > 0){
      let errors = ``;
      for(const [key, value] of currErrosRegister){
        errors += `<div>🟡 ${value}<div>`
      }
      let template = `<div id="custom-register-errors">
        <span>❎</span>
        ${errors}
      </div>
      `;
      $(this).before(template);
      return false;
    }
    
    verifyEmailShopify(email, currentElement);
    
  })

  $(document).on("click", "#octo-btn-register-submit-reclutador", function(e){
  
    e.preventDefault();
    
    let currentElement = this;
    currErrosRegister.clear();
    $(`#custom-register-errors`).remove();                                 
    let firstName = $(`#create_customer [data-id="first_name"]`).val();
    let lastName = $(`#create_customer [data-id="last_name"]`).val();
    let phone = $(`#create_customer [data-id="phone"]`).val();
    let phone_referral = $(`#create_customer [data-id="phone-referal"]`).val();
    let email = $(`#create_customer [data-id="email"]`).val();
    let password = $(`#create_customer  [data-id="password"]`).val();
    let type = $(`#create_customer [data-id="type"]`).val();
    let estado = $(`#create_customer [data-id="estado"]`).val();
    withoutSpaces(firstName, `first_name`, `Nombre`);
    withoutSpaces(lastName, `last_name`, `Apellidos`);
    onlyPhoneNumber(phone, `phone`, `Celular`);
    onlyEmail(email,`email`, `Email`);
    withoutSpaces(password, `password`, `Contraseña`);
    
    if(phone_referral){
      onlyPhoneNumber(phone_referral, `phone-referal`, `Celular de quien te Invitó`);
    }

    let errors = ``;
    if(currErrosRegister.size > 0){
      for(const [key, value] of currErrosRegister){
        errors += `<div>🟡 ${value}<div>`
      }
      let template = `<div id="custom-register-errors">
        <span>❎</span>
        ${errors}
      </div>
      `;
      $(this).before(template);
      return false;
    }

    $("#octo-btn-register-submit-reclutador").text("Enviando...");
    let urlemail = `https://www.natshop.com/apps/natshopv2?action=validate_acount&email=${email}`;
    fetch(urlemail)
    .then(data => data.text())
    .then((text) => {
      const obj = JSON.parse(text);
      if(obj.status === `failed` ){
        alert(`🟡 Esta dirección de correo electrónico (${email}) ya está en uso. Por favor, pruebe con otra.`);
        $("#octo-btn-register-submit-reclutador").text("Informes");
        return false;
      }else{
        let params = {
          "first_name": firstName,
          "last_name": lastName,
          "phone": phone,
          "email": email,
          "password": password,
          "type": type,
          "state": estado,
          "phone_referral": phone_referral
        };
        let query = Object.keys(params)
                 .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
                 .join('&');
    
        let url = 'http://natshop.octocode.xyz/api/v1/registro_reclutador?' + query;
        fetch(url)
        .then(data => data.text())
        .then((text) => {
          $(`#create_customer [data-id="first_name"]`).val('');
          $(`#create_customer [data-id="last_name"]`).val('');
          $(`#create_customer [data-id="phone"]`).val('');
          $(`#create_customer [data-id="email"]`).val('');
          $(`#create_customer [data-id="password"]`).val('');
          let template = `<div id="custom-register-errors" style="background:#5bafdc;">
            <span>❎</span>
            <div>Gracias por perdir informes, un asesor te contactará para darte toda la información necesaria y te habilitará tu cuenta.<div>
          </div>
          `;
          $("#octo-btn-register-submit-reclutador").before(template);
          $("#octo-btn-register-submit-reclutador").text("Informes");
        }).catch(function (error) {
          let template = `<div id="custom-register-errors" style="background: red;">
            <span>❎</span>
            <div>Ocurrio un error intentalo mas tarde<div>
          </div>
          `;
          $("#octo-btn-register-submit-reclutador").before(template);
          $("#octo-btn-register-submit-reclutador").text("Informes");
          console.log('request failed', error)
        });
      }
    }).catch(function (error) {
      let template = `<div id="custom-register-errors" style="background: red;">
        <span>❎</span>
        <div>Ocurrio un error intentalo mas tarde<div>
      </div>
      `;
      $("#octo-btn-register-submit-reclutador").before(template);
      $("#octo-btn-register-submit-reclutador").text("Informes");
      console.log('request failed', error)
    });
    
  })

  $(document).on("click", "#octo-btn-register-submit-reclutador2", function(e){
  
    e.preventDefault();
    
    let currentElement = this;
    currErrosRegister.clear();
    $(`#custom-register-errors`).remove();                                 
    let firstName = $(`#create_customer [data-id="first_name"]`).val();
    let lastName = $(`#create_customer [data-id="last_name"]`).val();
    let phone = $(`#create_customer [data-id="phone"]`).val();
    let email = $(`#create_customer [data-id="email"]`).val();
    let type = $(`#create_customer [data-id="type"]`).val();
    let estado = $(`#create_customer [data-id="estado"]`).val();
    let customer_id = $(`#create_customer [data-id="customer_id"]`).val();
    withoutSpaces(firstName, `first_name`, `Nombre`);
    withoutSpaces(lastName, `last_name`, `Apellidos`);
    onlyPhoneNumber(phone, `phone`, `Celular`);
    onlyEmail(email,`email`, `Email`);
    
    let errors = ``;
    if(currErrosRegister.size > 0){
      for(const [key, value] of currErrosRegister){
        errors += `<div>🟡 ${value}<div>`
      }
      let template = `<div id="custom-register-errors">
        <span>❎</span>
        ${errors}
      </div>
      `;
      $(this).before(template);
      return false;
    }

    $("#octo-btn-register-submit-reclutador2").text("Enviando...");
    let urlemail = `https://www.natshop.com/apps/natshopv2?action=validate_acount&email=${email}`;
    fetch(urlemail)
    .then(data => data.text())
    .then((text) => {
      const obj = JSON.parse(text);
      if(obj.status === `failed` ){
        alert(`🟡 Esta dirección de correo electrónico (${email}) ya está en uso. Por favor, pruebe con otra.`);
        $("#octo-btn-register-submit-reclutador2").text("Informes");
        return false;
      }else{

        let params = {
          "first_name": firstName,
          "last_name": lastName,
          "phone": phone,
          "email": email,
          "type": type,
          "state": estado,
          "customer_id": customer_id,
        };
        
        let query = Object.keys(params)
                     .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
                     .join('&');
        
        let url = 'https://natshop.octocode.xyz/api/v1/registro_coordinadores?' + query;
        fetch(url)
        .then(data => data.text())
        .then((text) => {
          $(`#create_customer [data-id="first_name"]`).val('');
          $(`#create_customer [data-id="last_name"]`).val('');
          $(`#create_customer [data-id="phone"]`).val('');
          $(`#create_customer [data-id="email"]`).val('');
          $(`#create_customer [data-id="type"]`).val('distribuidor').trigger("change");
          let template = `<div id="custom-register-errors" style="background:#5bafdc;">
            <span>❎</span>
            <div>Felicidades por tu nuevo referido, continua ganando por referir!<div>
          </div>
          `;
          $("#octo-btn-register-submit-reclutador2").before(template);
          $("#octo-btn-register-submit-reclutador2").text("Registrar");
        }).catch(function (error) {
          let template = `<div id="custom-register-errors" style="background: red;">
            <span>❎</span>
            <div>Ocurrio un error intentalo mas tarde<div>
          </div>
          `;
          $("#octo-btn-register-submit-reclutador2").before(template);
          $("#octo-btn-register-submit-reclutador2").text("Registrar");
          console.log('request failed', error)
        });
        
      }
    }).catch(function (error) {
      let template = `<div id="custom-register-errors" style="background: red;">
        <span>❎</span>
        <div>Ocurrio un error intentalo mas tarde<div>
      </div>
      `;
      $("#octo-btn-register-submit-reclutador2").before(template);
      $("#octo-btn-register-submit-reclutador2").text("Informes");
      console.log('request failed', error)
    });
    
  });
  
  $(document).on("click", "#octo-btn-register-submit-reclutador3", function(e){
  
    e.preventDefault();
    
    let currentElement = this;
    currErrosRegister.clear();
    $(`#custom-register-errors`).remove();                                 
    let firstName = $(`#create_customer [data-id="first_name"]`).val();
    let lastName = $(`#create_customer [data-id="last_name"]`).val();
    let phone = $(`#create_customer [data-id="phone"]`).val();
    let email = $(`#create_customer [data-id="email"]`).val();
    let type = $(`#create_customer [data-id="type"]`).val();
    let estado = $(`#create_customer [data-id="estado"]`).val();
    let customer_id = $(`#create_customer [data-id="customer_id"]`).val();
    withoutSpaces(firstName, `first_name`, `Nombre`);
    withoutSpaces(lastName, `last_name`, `Apellidos`);
    onlyPhoneNumber(phone, `phone`, `Celular`);
    onlyEmail(email,`email`, `Email`);

    let errors = ``;
    if(currErrosRegister.size > 0){
      for(const [key, value] of currErrosRegister){
        errors += `<div>🟡 ${value}<div>`
      }
      let template = `<div id="custom-register-errors">
        <span>❎</span>
        ${errors}
      </div>
      `;
      $(this).before(template);
      return false;
    }

    $("#octo-btn-register-submit-reclutador3").text("Enviando...");
    let urlemail = `https://www.natshop.com/apps/natshopv2?action=validate_acount&email=${email}`;
    fetch(urlemail)
    .then(data => data.text())
    .then((text) => {
      const obj = JSON.parse(text);
      if(obj.status === `failed` ){
        alert(`🟡 Esta dirección de correo electrónico (${email}) ya está en uso. Por favor, pruebe con otra.`);
        $("#octo-btn-register-submit-reclutador3").text("Informes");
        return false;
      }else{

        let params = {
          "first_name": firstName,
          "last_name": lastName,
          "phone": phone,
          "email": email,
          "type": type,
          "state": estado,
          "customer_id": customer_id,
        };
        
        let query = Object.keys(params)
                     .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
                     .join('&');
        
        let url = 'https://natshop.octocode.xyz/api/v1/registro_coordinadores?' + query;
        fetch(url)
        .then(data => data.text())
        .then((text) => {
          $(`#create_customer [data-id="first_name"]`).val('');
          $(`#create_customer [data-id="last_name"]`).val('');
          $(`#create_customer [data-id="phone"]`).val('');
          $(`#create_customer [data-id="email"]`).val('');
          $(`#create_customer [data-id="type"]`).val('distribuidor').trigger("change");
          let template = `<div id="custom-register-errors" style="background:#5bafdc;">
            <span>❎</span>
            <div>Felicidades por tu nuevo referido, continua ganando por referir!<div>
          </div>
          `;
          $("#octo-btn-register-submit-reclutador3").before(template);
          $("#octo-btn-register-submit-reclutador3").text("Registrar");
        }).catch(function (error) {
          let template = `<div id="custom-register-errors" style="background: red;">
            <span>❎</span>
            <div>Ocurrio un error intentalo mas tarde<div>
          </div>
          `;
          $("#octo-btn-register-submit-reclutador3").before(template);
          $("#octo-btn-register-submit-reclutador3").text("Registrar");
          console.log('request failed', error)
        });
        
      }
    }).catch(function (error) {
      let template = `<div id="custom-register-errors" style="background: red;">
        <span>❎</span>
        <div>Ocurrio un error intentalo mas tarde<div>
      </div>
      `;
      $("#octo-btn-register-submit-reclutador3").before(template);
      $("#octo-btn-register-submit-reclutador3").text("Informes");
      console.log('request failed', error)
    });
    
    
  })

  $(document).on("click", ".add-to-my-grup", function(e){
  
    e.preventDefault();
    $(this).text("Registrando...");
    let currentElement = $(this);
    $(`#custom-register-errors`).remove();                                 
    let firstName = $(this).attr("data-first_name");
    let lastName = $(this).attr("data-last_name");
    let phone = $(this).attr("data-phone");
    let email = $(this).attr("data-email");
    let type = $(this).attr("data-type");
    let estado = $(this).attr("data-estado");
    let customer_id = $(this).attr("data-customer_id");
    
    let params = {
      "first_name": firstName,
      "last_name": lastName,
      "phone": phone,
      "email": email,
      "type": type,
      "state": estado,
      "customer_id": customer_id,
    };
    
    let query = Object.keys(params)
                 .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
                 .join('&');
    
    let url = 'https://natshop.octocode.xyz/api/v1/registro_coordinadores?' + query;
    fetch(url)
    .then(data => data.text())
    .then((text) => {
      currentElement.remove();
    }).catch(function (error) {
      currentElement.remove();
    });
    
  })

  $(document).on("click", "#save-phone-new", function(e){
    e.preventDefault();
    $(`.formulario-phone .errors`).html(``);
    let phone = $(`#customer-phone-new`).val();
    if(phone === 0 || phone === undefined || phone === "" || expresionNoSpaces.test(phone) || phone.length != 10 || isNaN(phone)){
      $(`.formulario-phone .errors`).html(`El campo Número de celular debe ser a 10 dígitos.`);
      return false;
    }
    updatePhone(phone)
  })
  
  $(document).on("click", "#custom-register-errors > span", function(e){
    
    $(`#custom-register-errors`).remove();
    
  })
  
  $(document).on("click", ".expandable-content__toggle", function(e){
    let currEl = $(this).parents(".expandable-content--expandable")
    currEl.toggleClass("active")
    if($(currEl).hasClass( "active" )){
      $(currEl).attr("aria-expanded", true)
      $(this).find(`.expandable-content__toggle-text`).text(`Ver menos`)
    }else{
      $(currEl).attr("aria-expanded", false)
      $(this).find(`.expandable-content__toggle-text`).text(`Ver mas`)
    }
    setTimeout(function(){
      let currHeight = $(".template-product .container--flush .product-block-list__wrapper").height()
      let	expandedHeight = $(".template-product .container--flush .product-block-list__wrapper .card--collapsed .card__section").height()
      if(currHeight > expandedHeight){
        $(".template-product .container--flush .product-block-list").height(currHeight)
      }else{
        $(".template-product .container--flush .product-block-list").height(expandedHeight)
      }
    },260)
  })
  
  var params = getQueryParams(document.location.search);
  
  if(params.step == "firstlogin"){
  	$("#first-login").removeClass("hide")
  }
 
  
  $(document).on("click", "#announcement-bar-week-product span", function(){
    $(this).parents("#announcement-bar-week-product").remove();
  })

  $(document).on("click", ".close-popup", function(){
    $(".referidos-item-popup").removeClass("active")
  })

  $(document).on("click", ".layout__section__natshop__header__right__rewards", function(e){
    e.preventDefault();
    animateTopSection(".layout__section__natshop__rewrds")  
  }) 
  
  $("body.show-message-price .product-form__add-button").click(function(){
    $("#bar-show-message-price").remove();
    setTimeout(function(){
      $.getJSON("/cart.js", function(cart) {
        if( cart.total_price < 240000){
          let faltaAgregar = 240000 - cart.total_price;
          $("body.show-message-price").append(`
            <div id="bar-show-message-price">
                Estas cerca, agrega <span>$${faltaAgregar/100} MXN</span>
                para obtener un 40% de descuento en tu próxima compra 
                <span class="close-bar-show-message-price">X</span>
            </div>`);
        }
      });
    }, 1500);
    setTimeout(function(){
      $("#bar-show-message-price").remove();
    }, 10000);
  });
  
  $(document).on("click", ".close-bar-show-message-price", function(){
    $("#bar-show-message-price").remove();
  });

  var params = getQueryParams(document.location.search);
  //console.log(params.login)

  if(params.login){
    $(".template-login .fifty:first").hide()
    $("body").addClass("account-hide")
  }

  $(document).on("click", ".close", function(){
    $("html").removeClass("active-pop-Up")
  });

  $(document).on("click", "#octo-popup", function(e){
    e.stopPropagation();
    $("html").removeClass("active-pop-Up")
  });

  $(document).on("click", "#octo-popup > div > div:last-child", function(e){
    e.stopPropagation();
  });

  var date = new Date();
  var minutes = 60;
  var visited = $.cookie('visited');
  if (visited == 'yes') {      
    $("html").removeClass("active-pop-Up")    
  }
  else{    
    /*setTimeout(function(){ 
      $("html").addClass("active-pop-Up")
    }, 30000); */               
  }

  date.setTime(date.getTime() + (minutes * 60 * 1000)); 

  $.cookie('visited', 'yes', { expires: date });
  
  
  let customerId = $("#customer_id").val();
  let customerEmail = $("#customer_email").val();

  let currUrlHref =  window.location.href;
  if(currUrlHref.includes("kit-en-promocion?announcement=true") && customerEmail != ""){
    verifyProductStatus(customerEmail, "8000509837614");
  }else{
    $("#product-component-1671466276136").addClass("active");
  }
  
  if($(`body.template-account`).length > 0){
    /*if(customerId){
      let urlEstadoCuenta =`https://natshop.octocode.xyz/api/v1/get_estado_cuenta/${customerId}`;
      $.ajax({
        type: "GET",
        url: urlEstadoCuenta,    
        dataType: "json",
        contentType: "application/json",
        success:function(data) {
          let last_cash_out = withoutTime(data.last_cash_out);
          $(`.estado-cuenta-header-right-name`).html(`${data.customer.first_name} ${data.customer.last_name}`);
          $(`.estado-cuenta-header-right-email`).html(`${data.customer.email}`);
          $(`.estado-cuenta-header-right-date`).html(`${returDateTypeBank(last_cash_out)}`);
          $(`.estado-cuenta-header-right-puntos`).html(`Saldo en puntos: <b>${data.customer.points}</b>`);
          $(`.estado-cuenta-header-right-comisiones`).html(`Comisiones: <b>$${data.customer.cash ? data.customer.cash : 0} MXN</b>`);
          $(`.estado-cuenta-header-right-retirar`).html(`<a class="natshop-btn green" href="/pages/withdraw-balance">Retirar saldo</a>`);

          if(data.estado_cuenta_puntos.length > 0){
            Object.keys(data.estado_cuenta_puntos).forEach(function (k) {
              $("#estado-cuenta-table").append(`
                <tr>
                  <td>${withoutTime(data.estado_cuenta_puntos[k].date)}</td>
                  <td>${data.estado_cuenta_puntos[k].reference}</td>
                  <td>${data.estado_cuenta_puntos[k].description}</td>
                  <td ${data.estado_cuenta_puntos[k].importe >= 0 ? `style="color: green"`:`style="color: orange"`}>${data.estado_cuenta_puntos[k].importe}</td>
                  <td>${data.estado_cuenta_puntos[k].total}</td>
                </tr>
              `)
            });
          }else{
            $("#estado-cuenta-table").append(`
              <tr>
                <td>Aun no tienes puntos</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            `)
          }
          $("#estado-cuenta-table").append(`
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td><b>Total: ${data.customer.points}</b></td>
              <td></td>
            </tr>
          `)

          if(data.estado_cuenta_comisiones.length > 0){
            Object.keys(data.estado_cuenta_comisiones).forEach(function (k) {
              $("#estado-cuenta-table-2").append(`
                <tr>
                  <td>${withoutTime(data.estado_cuenta_comisiones[k].date)}</td>
                  <td>${data.estado_cuenta_comisiones[k].description}</td>
                  <td ${data.estado_cuenta_comisiones[k].importe >= 0 ? `style="color: green"`:`style="color: orange"`}>$${data.estado_cuenta_comisiones[k].importe} MXN</td>
                  <td>$${data.estado_cuenta_comisiones[k].total} MXN</td>
                </tr>
              `)
            });
          }else{
            $("#estado-cuenta-table-2").append(`
              <tr>
                <td>Aun no tienes comisiones</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            `)
          }
          $("#estado-cuenta-table-2").append(`
            <tr>
              <td></td>
              <td></td>
              <td><b>Total: $${data.customer.cash ? data.customer.cash : 0} MXN</b></td>
              <td></td>
            </tr>
          `)

        } 
      });
    }*/
  }
  
  const links_1 = document.getElementById('share_fb');
  const links_2 = document.getElementById('share_tw');
  
  if($("#customer_id").length > 0  && $(".template-account").length > 0){
    let customer_id =  document.getElementById('customer_id').value
    const url = encodeURIComponent("https://www.natshop.com/products/membresia-natshop?referredby="+customer_id);
    const title = encodeURIComponent("Natshop - Invita a un amigo");
    if(links_1){
      links_1.href = links_1.href
      .replace('{url}', url)
      .replace('{title}', title);
      links_1.addEventListener('click', onClick);
    }
    if(links_2){
      links_2.href = links_2.href
      .replace('{url}', url)
      .replace('{title}', title);
      links_2.addEventListener('click', onClick);
    }
  }
  
  var dateReferral = new Date();
  var minutesReferral = 600;
  var octo_referredby = $.cookie('octo_referredby');
  
  if($(".template-index").length > 0  || $(".template-register").length > 0 || $(".template-product").length > 0 || $(".afiliate").length > 0 ){
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const referredby = urlParams.get('referredby')
    if(referredby != null){
      dateReferral.setTime(dateReferral.getTime() + (minutes * 60 * 1000)); 
      $.cookie('octo_referredby', referredby, { expires: dateReferral, path: '/' });
    }
  }
  
  if($(".template-login").length > 0 || $(".template-register").length > 0 || $(".template-product").length > 0 || $(".afiliate").length > 0 ){
    if($.cookie('octo_referredby') != undefined){
      document.getElementById('ReferredBy').value = "["+$.cookie('octo_referredby')+"]"; 
    }else{
      console.log("NO HAY")
    }
  }
  
  if($(".template-product").length > 0){
    let firstSec,
        lastSec;
    setTimeout(function(){
      firstSec = $(".jdgm-rev-widg__header").html()
      lastSec = $(".jdgm-histogram").html()
      $("#octo-review-details").append(`
      <div>
        ${firstSec}
      </div>`)
      $("#octo-review-details .jdgm-widget-actions-wrapper, .jdgm-sort-dropdown-wrapper").remove()
    }, 1000);
  }
  
  $(document).on("click", ".octo-tooltip", function(e){
    e.stopPropagation()
    let heightItem = $(this).siblings(".info_tooltip").height()
    heightItem = heightItem + 8
    $(this).siblings(".info_tooltip").css({"top": -heightItem})      
    $(this).siblings(".info_tooltip").toggleClass("active")
  })
  
  $(document).on("click", "body", function(){
    $(".info_tooltip").removeClass("active")
  })

  $(document).on("click", ".info_tooltip.active", function(e){
    e.stopPropagation()    
  })
  
  $(document).on("click", ".layout__section__natshop__header__right__cart", function(e){
    animateTopSection(".natshop__card__table")  
  })
  
  $(document).on("click", "#premios_recibidos", function(e){
    $(".mis-premios-popup").addClass('active');
  })
  
  $(document).on("click", ".mis-premios-popup .close-popup", function(){
    $(".mis-premios-popup").removeClass("active")
  })
  
  $(document).on("click", "#comisisones_lider_b", function(e){
    $(".estado-cuenta-popup").addClass('active');
  })
  
  $(document).on("click", ".estado-cuenta-popup .close-popup", function(){
    $(".estado-cuenta-popup").removeClass("active")
  })
  
  $(document).on("click", ".natshop-section-cont__menu__title", function(){
    menuAccountStatus($(this))
  })
  

});

function onClick(event) {
  event.preventDefault();
  window.open(
    event.currentTarget.href,
    'Invita a un amigo',
    'width=600,height=500,location=no,menubar=no,toolbar=no'
  );
}


function validateCodeAccessError(err){
  console.log(err);
}

function copyToClipboard(element, currInsert) {
  var $temp = $("<input>");
  $("body").append($temp);
  $temp.val($(element).text()).select();
  document.execCommand("copy");
  $temp.remove();
  if(element == "#linkreferidos"){
    $(currInsert).append(`<span id="msj-copied"></p>`)
    setTimeout(function(){
      $("#msj-copied").remove() 
      $("#msj-copied").remove() 
      
    }, 1000);
    //$("#copyLinkReferidos").append(`<span id="msj-copied">Copiado</p>`)
  }
  
}

function getQueryParams(qs) {
  qs = qs.split('+').join(' ');
  var params = {},
      tokens,
      re = /[?&]?([^=]+)=([^&]*)/g;
  while (tokens = re.exec(qs)) {
    params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
  }
  return params;
}